



























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import {
  ChevronDownIcon,
  Edit2Icon,
  Trash2Icon,
  // @ts-ignore
} from "vue-feather-icons";
import Project from "@/models/project/project";

@Component({
  components: {
    ChevronDownIcon,
    Edit2Icon,
    Trash2Icon,
  },
  computed: {
    ...mapState("projects", ["projects"]),
    ...mapState("settings", ["availableHttpMethods"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class ProjectDetail extends Vue {
  // mapGetters + mapState
  projects!: Array<Project>;
  hasActiveSubscription!: boolean;

  get project(): Project | undefined {
    if (this.$route.params.id) {
      const project = this.projects.find(
        (project) => project.id == this.$route.params.id
      );
      return project;
    }

    return new Project();
  }

  mounted() {
    //
    // Redirect to Dashboard if no Project has been found
    if (!this.project) {
      this.$router.push({ name: "Dashboard" });
    }
  }
}
